<script setup>
import { ref, defineProps, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { useSalidaStore } from "@/store/useSalidaStore";
import { useCatalogos } from "@/composables/useCatalogos";
import { useAppToast } from "@/composables/useAppToast";

defineProps({
  visible: Boolean,
});
const emit = defineEmits(["update:visible"]);

const salida = useSalidaStore();
const cat = useCatalogos();
const toast = useAppToast();

const saving = ref(false);
const saved = ref(false);

const addConductor = async () => {
  const created = await cat.createConductor({ name: "" });
  if (created?.error) return toast.error("Ocurrió un error", created.error);
  salida.conductores.push({ id: created.id, name: created.name ?? "" });
};

const removeConductor = async (id) => {
  const res = await cat.deleteConductor(id);
  if (res?.error) return toast.error("Ocurrió un error", res.error);
  salida.conductores = salida.conductores.filter((c) => c.id !== id);
};

const save = async () => {
  saving.value = true;
  try {
    await Promise.all(
      salida.conductores.map((c) => cat.updateConductor(c.id, { name: c.name }))
    );
  } catch (e) {
    console.error(e);
    toast.error("Ocurrió un error", "No se pudieron guardar los cambios.");
    saving.value = false;
    return;
  }
  saving.value = false;
  saved.value = true;
  setTimeout(() => (saved.value = false), 2500);
};
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="(v) => emit('update:visible', v)"
    modal
    header="Conductores de salidas"
    :style="{ width: '460px' }"
  >
    <div class="text-sm text-500 mb-3">Editá el nombre directamente en cada campo.</div>
    <div class="item-list">
      <div v-for="item in salida.conductores" :key="item.id" class="item-row">
        <InputText v-model="item.name" class="flex-1" placeholder="Nombre del conductor" />
        <Button
          icon="pi pi-trash"
          text
          rounded
          severity="danger"
          size="small"
          v-tooltip.top="'Eliminar'"
          @click="removeConductor(item.id)"
        />
      </div>
      <div v-if="!salida.conductores.length" class="empty-state">
        Sin conductores configurados
      </div>
    </div>
    <Button
      icon="pi pi-plus"
      label="Agregar conductor"
      outlined
      size="small"
      class="mt-2"
      @click="addConductor"
    />
    <template #footer>
      <Button label="Cerrar" text @click="emit('update:visible', false)" />
      <Button
        :label="saved ? 'Guardado' : 'Guardar'"
        :icon="saved ? 'pi pi-check' : 'pi pi-save'"
        :loading="saving"
        @click="save"
      />
    </template>
  </Dialog>
</template>

<style scoped>
.item-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.item-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.empty-state {
  font-size: var(--text-callout);
  color: var(--label-tertiary);
  padding: 0.5rem 0;
  font-style: italic;
}
</style>
